import * as React from "react";
import Icon from "../../../../components/atoms/Icon";
import styles from "./styles.scss";

interface Props {
  isConnected: boolean;
}

const ZoomStatus: React.FC<Props> = ({ isConnected }) => {
  if (!isConnected) {
    return <p>ー</p>;
  }

  return (
    <div className={styles.zoomConnected}>
      <Icon name="icon-zoom" className={styles.svg} />
      <p>連携中</p>
    </div>
  );
};

export default ZoomStatus;
